import { render, staticRenderFns } from "./Pricingv2.vue?vue&type=template&id=4792611a&scoped=true&"
import script from "./Pricingv2.vue?vue&type=script&lang=js&"
export * from "./Pricingv2.vue?vue&type=script&lang=js&"
import style0 from "./Pricingv2.vue?vue&type=style&index=0&id=4792611a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4792611a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4792611a')) {
      api.createRecord('4792611a', component.options)
    } else {
      api.reload('4792611a', component.options)
    }
    module.hot.accept("./Pricingv2.vue?vue&type=template&id=4792611a&scoped=true&", function () {
      api.rerender('4792611a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Billing/Pricingv2.vue"
export default component.exports